/**
 * /devhub/release — Area E (Release). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/release')({ component: DevHubRelease });

function DevHubRelease() {
  return (
    <DevHubAreaShell
      title="Release"
      subtitle="Deploy + migration control and the secrets / API-keys board. High-risk actions enqueue a governed ActionFrame candidate — never a direct browser write."
      pages={[
        { label: 'Deploy Control', description: 'Candidate + disabled Deploy; blocked_requires_cloudflare_secret.', status: 'Phase 3' },
        { label: 'Migration Control', description: 'Candidate + disabled Apply; honest live status (not frozen blocked).', status: 'Phase 3' },
        { label: 'Secrets & API Keys', description: 'Live slot-status board + request ceremony; value entry stays local Keychain.', status: 'live', to: '/devhub/secrets' },
        { label: 'White-label Publish', description: 'White-label targets and publish gating.', status: 'live', to: '/devhub/white-label' },
        { label: 'Operator settings', description: 'Layout & white-label preferences (live PATCH /api/user-settings).', status: 'live', to: '/devhub/settings' },
      ]}
    />
  );
}
